export default {
  "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
  "fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["French"])},
  "routerErrorTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please refresh your browser"])},
  "routerErrorSubtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You are using an old version of Snapshot which is no longer available. Please refresh your browser."])}
}